import { render, staticRenderFns } from "./CommonImpersonate.vue?vue&type=template&id=59e89956&lang=pug&"
import script from "./CommonImpersonate.vue?vue&type=script&lang=js&"
export * from "./CommonImpersonate.vue?vue&type=script&lang=js&"
import style0 from "./CommonImpersonate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports